<template>
    <div class="bank-account-list-page-view">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>
                            <v-icon color="primary">currency_exchange</v-icon>
                            <p class="body-1 mt-3 ml-3 font-weight-bold primary--text">
                                Bank Account List
                            </p>
                            <v-spacer></v-spacer>
                            <v-btn depressed rounded class="primary lighten-1" @click="() => (createDialog = true)">
                                <v-icon>add</v-icon>
                                create new bank account
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="mt-5">
                            <v-data-table :page="page" :pageCount="numberOfPages" :search="search" :loading="loading"
                                :headers="headers" :items="bankAccounts" :items-per-page="itemsPerPage"
                                :options.sync="options" mobile-breakpoint="0" :server-items-length="totalCount">
                                <template v-slot:[`item.name`]="{ item }">
                                    <p
                                        class="number text--secondary blue--text font-weight-bold text-decoration-underline mt-4">
                                        {{ item.bankName }}</p>
                                </template>
                                <template v-slot:[`item.dailyLimit`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.dailyLimit }}</p>
                                </template>
                                <template v-slot:[`item.totalUseCount`]="{ item }">
                                    <p class="number text--secondary blue--text font-weight-medium font-mono mt-4">
                                        {{ item.totalUseCount }}</p>
                                </template>
                                <template v-slot:[`item.active`]="{ item }">
                                    <v-chip small dark :color="item.active ? 'green' : 'orange'">{{
                                        item.active ? "Active" : "Not-Active" }}</v-chip>
                                </template>
                                <template v-slot:[`item.update`]="{ item }">
                                    <v-btn icon @click="() => handleShowUpdateDialog(item)"
                                        class="text-secondary"><v-icon>edit</v-icon></v-btn>
                                </template>
                                <template v-slot:[`item.delete`]="{ item }">
                                    <v-btn icon @click="
                                        () => handleShowDeleteDialog(item)
                                    " class="text-secondary"><v-icon>delete</v-icon></v-btn>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>


        <v-dialog v-model="createDialog" width="500">
            <v-card>
                <v-card-title>
                    <v-icon color="primary">currency_exchange</v-icon>
                    <p class="body-1 mt-3 ml-3 font-weight-bold primary--text">
                        Create A New Bank Account
                    </p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Bank Name" placeholder="Enter bank name" filled rounded x-large
                                type="text" v-model="bankName" />
                            <v-text-field label="Daily Limit" placeholder="0" filled rounded x-large type="number"
                                v-model="dailyLimit" />
                            <v-select :items="['Active', 'In-Active']" label="Active" filled rounded x-large></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" text x-large @click="() => (createDialog = false)">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text x-large :loading="addLoading" @click="handleAddNew">
                        <v-icon>save</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateDialog" width="500">
            <v-card>
                <v-card-title>
                    <v-icon color="primary">currency_exchange</v-icon>
                    <p class="body-1 mt-3 ml-3 font-weight-bold primary--text">
                        Update Account
                    </p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Bank Name" placeholder="Enter bank name" filled rounded x-large
                                type="text" v-model="bankName" />
                            <v-text-field label="Daily Limit" placeholder="0" filled rounded x-large type="number"
                                v-model="dailyLimit" />
                            <v-select :items="['Active', 'In-Active']" label="Active" filled rounded x-large
                                v-model="active"></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" text x-large @click="() => (updateDialog = false)">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text x-large :loading="updateLoading" @click="handleUpdate">
                        <v-icon>save</v-icon>
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" width="500">
            <v-card>
                <v-card-title>
                    <v-icon color="red">warning</v-icon>
                    <p class="body-1 mt-3 ml-3 font-weight-bold red--text">Warning</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-5">
                    Please confirm that you want to delete this trade.This action can't be
                    revert.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" text x-large @click="() => (deleteDialog = false)">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text x-large :loading="deleteLoading" @click="handleDeleteBankAccount">
                        <v-icon>delete</v-icon>
                        delete account
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>
<script>
import { bankAccountApi } from "@/api"

export default {
    name: "BankAccountListPageView",
    data: function () {
        return {
            page: 1,
            numberOfPages: null,
            search: null,
            loading: false,
            bankAccounts: [],
            itemsPerPage: 10,
            totalCount: null,
            options: {},
            headers: [
                {
                    text: "Bank Name", value: "bankName"
                },
                {
                    text: "Daily Limit", value: "dailyLimit"
                },
                {
                    text: "Total Use Count", value: "totalUseCount"
                },
                {
                    text: "Active", value: "active"
                },
                {
                    text: "Update", value: "update"
                },
                {
                    text: "Delete", value: "delete"
                },
            ],
            createDialog: false,
            addLoading: false,
            deleteDialog: false,
            deleteLoading: false,
            updateDialog: false,
            updateLoading: false,
            bankName: "",
            dailyLimit: "",
            active: null,
            selectedItem: null
        }
    },
    methods: {
        handleAddNew: async function () {
            this.addLoading = true;

            const bankAccount = {
                bankName: this.bankName,
                dailyLimit: this.dailyLimit,
                active: this.active
            }

            try {
                await bankAccountApi.createBankAccount(bankAccount);
                this.loadBankAccounts(this.options.page, this.options.itemsPerPage);
            } catch (error) {
                console.log(error);
            }

            this.addLoading = false;
            this.createDialog = false;
        },
        handleUpdate: async function () {
            this.updateLoading = true;

            const bankAccount = {
                bankName: this.bankName,
                dailyLimit: this.dailyLimit,
                active: this.active == "Active"
            }

            console.log("bank account : ",);


            try {
                await bankAccountApi.updateBankAccount(this.selectedItem, bankAccount)
                this.loadBankAccounts(this.options.page, this.options.itemsPerPage);
            } catch (error) {
                console.log(error);
            }

            this.updateLoading = false;
            this.updateDialog = false;
        },
        handleShowUpdateDialog: function (item) {
            this.selectedItem = item._id
            this.bankName = item.bankName
            this.dailyLimit = item.dailyLimit
            this.active = item.active

            this.updateDialog = true;
        },
        handleShowDeleteDialog: function (item) {
            console.log(item);
            
            this.selectedItem = item._id;
            this.deleteDialog = true;
        },
        handleDeleteBankAccount: async function () {
            this.deleteLoading = true;

            console.log(this.selectedItem);
            

            try {
                await bankAccountApi.deleteBankAccount(this.selectedItem)
                this.loadBankAccounts(this.options.page, this.options.itemsPerPage);
            } catch (error) {
                console.log(error);
            }

            this.deleteLoading = false;
            this.deleteDialog = false;
        },
        loadBankAccounts: async function (page, limit) {
            this.loading = true;

            try {
                const data = await bankAccountApi.getBankAccounts(page, limit);

                this.bankAccounts = data.bankAccounts;
                this.page = data.currentPage;
                this.numberOfPages = data.totalPages;
                this.totalCount = data.totalCount;
            } catch (error) {
                console.log(error);
            }

            this.loading = false;
        }
    },
    watch: {
        options: function (options) {
            this.loadBankAccounts(options.page, options.itemsPerPage);
        }
    }
}

</script>